import styled from 'styled-components';

export const TooltipChild = styled.div`
  text-align: center;
  border-radius: 2px;
  cursor: help;
  position: absolute;
  top: -16px;
  right: 25px;
`;

export const TooltipBox = styled.div`
  font-size: 8px;
  line-height: 11px;
  padding: 5px;
  border-radius: 2px;
  visibility: hidden;
  position: absolute;
  top: -61px;
  left: 113px;
  width: 240px;
`;

export const Tooltip = styled.div`
  position: relative;
  & ${TooltipChild}:hover + ${TooltipBox} {
    visibility: visible;
    background: ${({ boxColor }) => boxColor};
    color: ${({ textColor }) => textColor};
    border-radius: 2px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Tooltip/style.js